import React from 'react';

const ListContext = React.createContext<string>('');
export default ListContext;
